export const listAnimation = {
  initial: { y: 100, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: -50, opacity: 0 },
}

export const verticalListAnimation = {
  initial: { x: -20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: 100, opacity: 0 },
}

export const rightInAnimation = {
  initial: { x: 20, opacity: 0 },
  animate: { x: 0, opacity: 1 },
  exit: { x: -100, opacity: 0 },
}

export const opacityAnimation = {
  initial: {
    opacity: .2,
    transition: { duration: 0.2 }
  },
  animate: { opacity: 1 },
  exit: {
    opacity: .2,
    transition: { duration: 0.2 }
  },
}

export const bottomEnterAnimation = {
  initial: { y: 100, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: 100, opacity: 0 },
}